import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  readAdminCustomerRouteParam,
  readRouteParam,
} from '../../../_utils/route-param.utils';
import { AdminDetailShellComponent, AdminDetailTab } from '../../../components/admin-ui/admin-detail-shell/admin-detail-shell.component';

@Component({
  selector: 'app-admin-role-detail',
  standalone: true,
  imports: [AdminDetailShellComponent],
  templateUrl: './admin-role-detail.component.html',
  styleUrl: './admin-role-detail.component.scss',
})
export class AdminRoleDetailComponent implements OnInit {
  public customersId = 0;
  public tabs: AdminDetailTab[] = [
    {
      route: 'edit',
      labelKey: 'COMMON.EDIT',
      icon: 'fas fa-pen',
    },
    {
      route: 'permissions',
      labelKey: 'COMMON.PERMISSIONS',
      icon: 'fas fa-key',
    },
    {
      route: 'widgets',
      labelKey: 'COMMON.WIDGETS',
      icon: 'fas fa-plug',
    },
  ];

  constructor(private readonly route: ActivatedRoute) {}

  get backLink(): any[] {
    return [
      '/administration',
      readAdminCustomerRouteParam(this.route, this.customersId) || this.customersId,
      'roles',
    ];
  }

  ngOnInit(): void {
    this.customersId = readRouteParam(this.route, 'customers_id');
  }
}
